"use strict";
// copy from zpdes_tools.ts
// use deepCopy
Object.defineProperty(exports, "__esModule", { value: true });
exports.zip = void 0;
exports.func_sum = func_sum;
exports.func_mean = func_mean;
exports.argMax = argMax;
exports.randomChoice = randomChoice;
exports.randomChoices = randomChoices;
exports.deepCopy = deepCopy;
exports.truncate = truncate;
exports.feel_list_with_values_if_empty = feel_list_with_values_if_empty;
const zip = (arr, ...arrs) => {
    return arr.map((val, i) => arrs.reduce((a, arr) => [...a, arr[i]], [val]));
};
exports.zip = zip;
function func_sum(array) {
    const sum1 = array.reduce((accumulator, currentValue) => accumulator + currentValue);
    return sum1;
}
function func_mean(array) {
    var suma = 0;
    for (let x of array) {
        suma += x;
    }
    var mean = suma / array.length;
    return mean;
}
function argMax(array) {
    return array.map((x, i) => [x, i]).reduce((r, a) => (a[0] > r[0] ? a : r))[1];
}
// Generates a random element (index) from a given 1-D array of probabilities
function randomChoice(p) {
    let rnd = p.reduce((a, b) => a + b) * Math.random();
    return p.findIndex(a => (rnd -= a) < 0);
}
// Generates a random sample from a given 1-D array probabilities //similar to np.random.choice
function randomChoices(p, count) {
    return Array.from(Array(count), randomChoice.bind(null, p));
}
function deepCopy(obj) {
    var copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj)
        return obj;
    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (let i = 0, len = obj.length; i < len; i++) {
            copy[i] = deepCopy(obj[i]);
        }
        return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (let attr in obj) {
            if (obj.hasOwnProperty(attr))
                copy[attr] = deepCopy(obj[attr]);
        }
        return copy;
    }
}
function truncate(val, low = 0, high = 1) {
    let truncatedVal = val;
    if (val < low) {
        truncatedVal = low;
    }
    else if (val > high) {
        truncatedVal = high;
    }
    return truncatedVal;
}
function feel_list_with_values_if_empty(default_val, list_to_feel, number_of_value_to_feel) {
    if (list_to_feel.length == 0) {
        for (let i = 0; i < number_of_value_to_feel; i++)
            list_to_feel.push(default_val);
    }
    return list_to_feel;
}
